// extracted by mini-css-extract-plugin
export default {"root":"_1xsl8","body":"_3CPs6","footer":"XIEgu","user-field":"_2PzoE","userField":"_2PzoE","user-input":"_39e73","userInput":"_39e73","prefix":"aZ988"};